import { isValidEmail } from '@/shared/utils/contato';
import { isValidCpfCnpj, normalizeCpfCnpj } from '@/shared/utils/documentValidation';
import type { LoginDocumentoType, LoginIdentifierType } from '@/types/auth/authTypes';

// Só dígitos e pontuação: o CNPJ alfanumérico fica de fora porque o `loginDispatchSchema`
// do core recusa letras e a busca da conta compara `pessoa.cpfCnpj` apenas por dígitos.
const DOCUMENTO_LIKE_REGEX = /^[\d.\-/\s]*$/;

// Mesmo corte do `applyCpfCnpjMask`: passou de 11 dígitos, a máscara já é de CNPJ.
const CPF_LENGTH = 11;

export const looksLikeDocumento = (value: string): boolean =>
  DOCUMENTO_LIKE_REGEX.test(value) && normalizeCpfCnpj(value).length > 0;

export const detectLoginIdentifierType = (value: string): LoginIdentifierType => {
  if (value.includes('@')) return 'EMAIL';
  if (!looksLikeDocumento(value)) return 'UNKNOWN';
  return normalizeCpfCnpj(value).length > CPF_LENGTH ? 'CNPJ' : 'CPF';
};

export const isDocumentoType = (type: LoginIdentifierType): type is LoginDocumentoType =>
  type === 'CPF' || type === 'CNPJ';

export const isLoginIdentifierValid = (raw: string): boolean => {
  const trimmed = raw.trim();
  const type = detectLoginIdentifierType(trimmed);
  if (type === 'EMAIL') return isValidEmail(trimmed);
  if (isDocumentoType(type)) return isValidCpfCnpj(trimmed);
  return false;
};

// Deriva o tipo em vez de recebê-lo: um par (valor, tipo) inconsistente mandaria letras como
// CNPJ. Assim, o que não é documento segue como digitado e o core recusa com 400, sem mutilar.
export const toSubmittedLoginIdentifier = (trimmed: string): string =>
  isDocumentoType(detectLoginIdentifierType(trimmed)) ? normalizeCpfCnpj(trimmed) : trimmed;

export const buildDocumentoNaoEncontradoMessage = (tipo: LoginDocumentoType): string =>
  `Não encontramos uma notificação para este ${tipo}. Verifique se o documento está correto.`;
